import React, { useState } from 'react';
import { Modal, Form, Radio, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadBase } from '../../../util/tool';
import { confirmReconciliation } from '../api';
import './index.less';

export default function Signature(props) {
  const { reconciliation_no, update = () => { }, onCancel = () => { } } = props;
  const radioOptions = [{ label: '电子签章', value: 1, }, { label: '已签章账单上传', value: 2, }];
  const [visible] = useState(reconciliation_no);
  const [signPicList, setSignPicList] = useState([]);
  const [signFileList, setSignFileList] = useState([]);
  const [signatureForm] = Form.useForm();
  const initialValues = { signature_type: 1 };
  const signature_type = Form.useWatch('signature_type', signatureForm);
  const signPicBeforeUpload = ({ size }) => {
    const condition = size <= 1024 * 1024 * 2;
    if (!condition) {
      message.error('上传文件要求: jpg、jpeg、png格式，大小不超过2M!');
    }
    return condition;
  };
  const signPicChange = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    setSignPicList([currentItem]);
  };
  const signFileBeforeUpload = ({ size }) => {
    const condition = size <= 1024 * 1024 * 10;
    if (!condition) {
      message.error('上传文件要求：pdf、jpg、jpeg、png格式，大小不超过10M!');
    }
    return condition;
  };
  const signFileChange = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    setSignFileList([currentItem]);
  };

  const onOk = async () => {
    const { signature_type } = await signatureForm.validateFields();
    const signature_file = signature_type === 1 ? signPicList : signFileList;
    const data = { signature_type, signature_file };
    const { data: { code, msg } } = await confirmReconciliation({ reconciliation_no, ...data });
    if (+code === 0) {
      update();
    } else {
      message.error(msg);
    }
  };

  return (
    <div className='signature-modal-container'>
      <Modal open={visible} width={800} title=' ' getContainer={false} onOk={onOk} destroyOnClose onCancel={onCancel}>
        <Form form={signatureForm} initialValues={initialValues}>
          <Form.Item label="该账单需要签章，请选择签章方式" name='signature_type'
            rules={[
              {
                required: true,
                message: '请选择签章方式!',
              },
            ]}>
            <Radio.Group options={radioOptions} />
          </Form.Item>
          {
            signature_type === 1 ?
              <Form.Item label="电子签章"
                name='signature_file1'
                rules={[
                  {
                    required: true,
                    message: '请上传电子签章!',
                  },
                ]}>
                <Upload
                  name="file"
                  headers={{ token: localStorage.getItem('token') }}
                  listType="picture-card"
                  customRequest={(file) => signPicChange(file)}
                  beforeUpload={signPicBeforeUpload}
                  accept="image/png, image/jpeg,image/jpg"
                  fileList={signPicList}
                  onRemove={() => { setSignPicList([]); }}
                >
                  {
                    !signPicList.length ? <>
                      <div className='signature-upload-explain signature-upload-pic' >
                        <Button type='text' size='small' icon={<UploadOutlined />} style={{ marginBottom: 20 }}>上传</Button>
                        <div className='signature-upload-text'>要求：jpg、jpeg、png格式，大小不超过2M</div>
                      </div>
                    </> : null
                  }
                </Upload>
              </Form.Item>
              :
              <Form.Item label="已签章账单"
                name='signature_file2'
                rules={[
                  {
                    required: true,
                    message: '请上传已签章账单!',
                  },
                ]}>
                <Upload
                  name="file"
                  headers={{ token: localStorage.getItem('token') }}
                  // listType="picture-card"
                  customRequest={(file) => signFileChange(file)}
                  beforeUpload={signFileBeforeUpload}
                  accept="image/png, image/jpeg,image/jpg,application/pdf"
                  fileList={signFileList}
                  onRemove={() => { setSignFileList([]); }}
                >
                  {
                    !signFileList.length ? <>
                      <div className='signature-upload-explain' >
                        <Button icon={<UploadOutlined />}>上传</Button>
                        <div className='signature-upload-text'>要求：pdf、jpg、jpeg、png格式，大小不超过10M</div>
                      </div>
                    </> : null
                  }
                </Upload>
              </Form.Item>
          }
        </Form>
      </Modal>
    </div>
  );
}
